import React, { Component } from "react";

import { SketchPicker } from "react-color";

import "./svgviewer.css";

import { GiSewingMachine, GiSewingNeedle } from "react-icons/gi";

class SvgViewer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      design: null,

      preview: {
        stitches: 0,
        colors: 0,
        jumps: 0,
        width: 0,
        height: 0,
      },

      rpm: 700,

      pricePer10k: 50,

      loading: false,

      scale: 1,

      offsetX: 0,

      offsetY: 0,

      selectedColor: null,

      pickerColor: "#ff0000",

      showPicker: false,

      colorMap: {},

      backgroundColor: "#f8fafc",

      cursorHint: null,
    };

    this.svgRef = React.createRef();

    this.drag = {
      isDragging: false,

      hasMoved: false,

      lastX: 0,

      lastY: 0,
    };

    this.cursorHintTimer = null;
  }

  // =========================================================

  // UPLOAD

  // =========================================================

  uploadFile = async (e) => {
    const input = e.target;

    const file = input.files[0];

    if (!file) return;

    const formData = new FormData();

    formData.append("file", file);

    try {
      this.setState({
        loading: true,

        showPicker: false,
      });

      const res = await fetch(
        "https://jccreations.boutique/api/embroidery/upload-metadata",

        {
          method: "POST",

          body: formData,
        },
      );

      const data = await res.json();
      console.log("Upload response:", data);

      if (data.success) {
        this.setState(
          {
            design: data.design,

            scale: 1,

            offsetX: 0,

            offsetY: 0,

            selectedColor: null,

            pickerColor: "#ff0000",

            showPicker: false,

            colorMap: {},

            backgroundColor: "#f8fafc",

            preview: {
              stitches: data.design.stitchCount,

              colors: data.design.colorCount,

              jumps: data.design.jumpCount,

              width: data.design.width,

              height: data.design.height,
            },
          },

          () => {
            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                this.fitToScreen();
              });
            });
          },
        );
      } else {
        alert(data.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);

      alert("Upload error");
    } finally {
      this.setState({
        loading: false,
      });

      // Safe because we saved the input before await

      if (input) {
        input.value = "";
      }
    }
  };

  // =========================================================

  // BUILD PATHS

  // =========================================================

  buildPaths = (stitches) => {
    const grouped = {};

    let minX = Infinity;

    let minY = Infinity;

    let maxX = -Infinity;

    let maxY = -Infinity;

    stitches.forEach((s, i) => {
      const x = Number(s.x);

      const y = Number(s.y);

      if (!Number.isFinite(x) || !Number.isFinite(y)) {
        return;
      }

      if (s.type === "jump" || s.jump === true || s.isJump === true) {
        return;
      }

      const colorKey =
        s.color !== undefined &&
        s.color !== null &&
        String(s.color).trim() !== ""
          ? String(s.color)
          : `auto\_${i}`;

      if (!grouped[colorKey]) {
        grouped[colorKey] = [];
      }

      grouped[colorKey].push({
        x,

        y,
      });

      minX = Math.min(minX, x);

      minY = Math.min(minY, y);

      maxX = Math.max(maxX, x);

      maxY = Math.max(maxY, y);
    });

    if (!Number.isFinite(minX)) {
      minX = 0;

      minY = 0;

      maxX = 1;

      maxY = 1;
    }

    return {
      paths: grouped,

      bounds: {
        minX,

        minY,

        width: Math.max(1, maxX - minX),

        height: Math.max(1, maxY - minY),
      },
    };
  };

  // =========================================================

  // BUILD PATH

  // =========================================================

  buildPath = (points) => {
    if (!points || points.length === 0) {
      return "";
    }

    let d = `M ${points[0].x} ${points[0].y}`;

    for (let i = 1; i < points.length; i++) {
      d += ` L ${points[i].x} ${points[i].y}`;
    }

    return d;
  };

  // =========================================================

  // COLOR PALETTE

  // =========================================================

  getPaletteColor = (key, index) => {
    const palette = [
      "#e96125",

      "#2563eb",

      "#16a34a",

      "#9333ea",

      "#f59e0b",

      "#ef4444",

      "#14b8a6",

      "#64748b",

      "#ec4899",

      "#84cc16",

      "#06b6d4",

      "#f97316",

      "#8b5cf6",

      "#22c55e",

      "#dc2626",

      "#0f766e",

      "#be123c",

      "#7c3aed",

      "#ca8a04",

      "#475569",
    ];

    /*

      Use the key when possible.

      If the key isn't numeric, use the path index.

    */

    const number = parseInt(key, 36);

    if (Number.isFinite(number)) {
      return palette[Math.abs(number) % palette.length];
    }

    return palette[index % palette.length];
  };

  // =========================================================

  // GET SVG POSITION

  // =========================================================

  getSvgPoint = (clientX, clientY) => {
    const svg = this.svgRef.current;

    if (!svg) {
      return {
        x: 0,

        y: 0,
      };
    }

    const rect = svg.getBoundingClientRect();

    const viewBox = svg.viewBox.baseVal;

    if (!rect.width || !rect.height || !viewBox.width || !viewBox.height) {
      return {
        x: viewBox.x,

        y: viewBox.y,
      };
    }

    /*

      Because preserveAspectRatio is "meet",

      calculate the actual displayed SVG area.

    */

    const viewBoxRatio = viewBox.width / viewBox.height;

    const containerRatio = rect.width / rect.height;

    let renderedWidth;

    let renderedHeight;

    let offsetLeft;

    let offsetTop;

    if (containerRatio > viewBoxRatio) {
      renderedHeight = rect.height;

      renderedWidth = renderedHeight * viewBoxRatio;

      offsetLeft = (rect.width - renderedWidth) / 2;

      offsetTop = 0;
    } else {
      renderedWidth = rect.width;

      renderedHeight = renderedWidth / viewBoxRatio;

      offsetLeft = 0;

      offsetTop = (rect.height - renderedHeight) / 2;
    }

    const localX = clientX - rect.left - offsetLeft;

    const localY = clientY - rect.top - offsetTop;

    const x = viewBox.x + (localX / renderedWidth) * viewBox.width;

    const y = viewBox.y + (localY / renderedHeight) * viewBox.height;

    return {
      x,

      y,
    };
  };

  // =========================================================

  // MOUSE DOWN

  // =========================================================

  onMouseDown = (e) => {
    if (e.button !== 0) return;

    if (this.cursorHintTimer) {
      clearTimeout(this.cursorHintTimer);
      this.cursorHintTimer = null;
    }

    this.setState({ cursorHint: null });

    this.drag.isDragging = true;
    this.drag.hasMoved = false;
    this.drag.lastX = e.clientX;
    this.drag.lastY = e.clientY;

    if (this.svgRef.current) {
      this.svgRef.current.style.cursor = "grabbing";
    }
  };
  // =========================================================

  // MOUSE MOVE

  // =========================================================

  onMouseMove = (e) => {
    const svg = this.svgRef.current;
    if (!svg) return;

    // While panning, hide the tooltip and preserve existing movement.
    if (this.drag.isDragging) {
      if (this.cursorHintTimer) {
        clearTimeout(this.cursorHintTimer);
        this.cursorHintTimer = null;
      }

      this.setState({ cursorHint: null });

      const rect = svg.getBoundingClientRect();
      const viewBox = svg.viewBox.baseVal;

      if (!rect.width || !rect.height) return;

      const screenDX = e.clientX - this.drag.lastX;
      const screenDY = e.clientY - this.drag.lastY;

      if (Math.abs(screenDX) > 2 || Math.abs(screenDY) > 2) {
        this.drag.hasMoved = true;
      }

      const dx = screenDX * (viewBox.width / rect.width);
      const dy = screenDY * (viewBox.height / rect.height);

      this.setState((prev) => ({
        offsetX: prev.offsetX + dx,
        offsetY: prev.offsetY + dy,
      }));

      this.drag.lastX = e.clientX;
      this.drag.lastY = e.clientY;

      return;
    }

    // Work out whether the pointer is over a selectable thread.
    const target = e.target;
    const hitPath =
      target instanceof Element ? target.closest(".sv-hit-path") : null;

    const hintType = hitPath ? "thread" : "background";
    const container = svg.closest(".sv-svg-container");

    if (!container) return;

    const rect = container.getBoundingClientRect();

    // Position the hint near the pointer, keeping it inside the canvas.
    const x = Math.max(
      8,
      Math.min(e.clientX - rect.left + 14, rect.width - 245),
    );

    const y = Math.max(
      8,
      Math.min(e.clientY - rect.top + 14, rect.height - 54),
    );

    if (this.cursorHintTimer) {
      clearTimeout(this.cursorHintTimer);
    }

    // Hide any previous hint until the pointer becomes still.
    this.setState({ cursorHint: null });

    this.cursorHintTimer = setTimeout(() => {
      this.cursorHintTimer = null;

      if (!this.drag.isDragging) {
        this.setState({
          cursorHint: {
            type: hintType,
            x,
            y,
          },
        });
      }
    }, 400);
  };

  // =========================================================

  // MOUSE UP

  // =========================================================

  onMouseUp = () => {
    this.drag.isDragging = false;

    if (this.svgRef.current) {
      this.svgRef.current.style.cursor = "grab";
    }

    /*

      Keep hasMoved available until the click event

      finishes.

    */

    setTimeout(() => {
      this.drag.hasMoved = false;
    }, 0);
  };

  // =========================================================

  // MOUSE LEAVE

  // =========================================================

  onMouseLeave = () => {
    this.drag.isDragging = false;

    if (this.cursorHintTimer) {
      clearTimeout(this.cursorHintTimer);
      this.cursorHintTimer = null;
    }

    this.setState({ cursorHint: null });

    if (this.svgRef.current) {
      this.svgRef.current.style.cursor = "grab";
    }
  };
  // =========================================================

  // WHEEL ZOOM

  // =========================================================

  onWheel = (e) => {
    /*

      VERY IMPORTANT:

      Stop browser/page scrolling.

    */

    e.preventDefault();

    e.stopPropagation();

    const oldScale = this.state.scale;

    const zoomFactor = e.deltaY < 0 ? 1.12 : 1 / 1.12;

    let newScale = oldScale * zoomFactor;

    newScale = Math.max(
      0.35,

      Math.min(60, newScale),
    );

    if (newScale === oldScale) {
      return;
    }

    /*

      Find exactly where the mouse is

      inside the SVG.

    */

    const mousePoint = this.getSvgPoint(
      e.clientX,

      e.clientY,
    );

    const ratio = newScale / oldScale;

    /*

      Keep the point under the cursor fixed.

    */

    const newOffsetX =
      mousePoint.x - (mousePoint.x - this.state.offsetX) * ratio;

    const newOffsetY =
      mousePoint.y - (mousePoint.y - this.state.offsetY) * ratio;

    this.setState({
      scale: newScale,

      offsetX: newOffsetX,

      offsetY: newOffsetY,
    });
  };

  // =========================================================

  // ZOOM IN

  // =========================================================

  zoomIn = () => {
    this.zoomAroundCenter(1.2);
  };

  // =========================================================

  // ZOOM OUT

  // =========================================================

  zoomOut = () => {
    this.zoomAroundCenter(1 / 1.2);
  };

  // =========================================================

  // ZOOM AROUND CENTER

  // =========================================================

  zoomAroundCenter = (factor) => {
    const svg = this.svgRef.current;

    if (!svg) {
      return;
    }

    const rect = svg.getBoundingClientRect();

    const centerX = rect.left + rect.width / 2;

    const centerY = rect.top + rect.height / 2;

    const centerPoint = this.getSvgPoint(
      centerX,

      centerY,
    );

    const oldScale = this.state.scale;

    let newScale = oldScale * factor;

    newScale = Math.max(
      0.35,

      Math.min(60, newScale),
    );

    if (newScale === oldScale) {
      return;
    }

    const ratio = newScale / oldScale;

    const newOffsetX =
      centerPoint.x - (centerPoint.x - this.state.offsetX) * ratio;

    const newOffsetY =
      centerPoint.y - (centerPoint.y - this.state.offsetY) * ratio;

    this.setState({
      scale: newScale,

      offsetX: newOffsetX,

      offsetY: newOffsetY,
    });
  };

  // =========================================================

  // FIT DESIGN TO VIEWER

  // =========================================================

  fitToScreen = () => {
    if (!this.svgRef.current || !this.state.design?.stitches) return;

    /*
      The SVG viewBox is built from the complete stitch bounds and uses
      preserveAspectRatio="xMidYMid meet". Let SVG perform the fit so the
      original proportions remain intact; resetting the group transform
      returns the complete design to the centered, fitted view.
    */
    this.setState({
      scale: 1,
      offsetX: 0,
      offsetY: 0,
      selectedColor: null,
      showPicker: false,
    });
  };

  // =========================================================

  // SELECT COLOR

  // =========================================================

  selectColor = (e, key, color) => {
    e.preventDefault();

    e.stopPropagation();

    if (this.drag.hasMoved) {
      return;
    }

    this.setState({
      selectedColor: key,

      pickerColor: color,

      showPicker: true,
    });
  };

  // =========================================================

  // APPLY COLOR

  // =========================================================

  selectBackground = (e) => {
    if (e.target !== e.currentTarget || this.drag.hasMoved) return;

    this.setState({
      selectedColor: "__background__",
      pickerColor: this.state.backgroundColor,
      showPicker: true,
    });
  };

  applyColor = () => {
    const { selectedColor, pickerColor } = this.state;
    if (selectedColor === null || selectedColor === undefined) return;

    if (selectedColor === "__background__") {
      this.setState({
        backgroundColor: pickerColor,
        showPicker: false,
        selectedColor: null,
      });
      return;
    }

    this.setState((prev) => ({
      colorMap: {
        ...prev.colorMap,
        [selectedColor]: pickerColor,
      },
      showPicker: false,
      selectedColor: null,
    }));
  };

  // =========================================================

  // CANCEL COLOR

  // =========================================================

  cancelColorPicker = () => {
    this.setState({
      showPicker: false,

      selectedColor: null,
    });
  };

  mmToInch = (mm) => {
    if (!mm) return 0;
    return (mm / 25.4).toFixed(2);
  };

  clearDesign = () => {
    this.setState({
      design: null,

      preview: {
        stitches: 0,
        colors: 0,
        jumps: 0,
        width: 0,
        height: 0,
      },

      scale: 1,
      offsetX: 0,
      offsetY: 0,

      selectedColor: null,
      pickerColor: "#ff0000",
      showPicker: false,

      colorMap: {},
      backgroundColor: "#f8fafc",
    });
  };

  // =========================================================

  // RENDER

  // =========================================================

  render() {
    const {
      design,

      loading,

      scale,

      offsetX,

      offsetY,

      colorMap,

      selectedColor,

      showPicker,

      pickerColor,
      backgroundColor,

      preview,

      cursorHint,
    } = this.state;

    const pathsData = design?.stitches
      ? this.buildPaths(design.stitches)
      : null;

    const rpmProgress = ((this.state.rpm - 350) / (1200 - 350)) * 100;

    const priceProgress = ((this.state.pricePer10k - 50) / (500 - 50)) * 100;

    return (
      <div className="sv-page">
        {/* =================================================

            BODY

        \================================================= */}

        <main className="sv-body">
          {/* =================================================

              TOP SECTION

          \================================================= */}

          <section className="sv-page-intro">
            <div>
              <div className="sv-eyebrow">JC CREATIONS · WORKSPACE</div>
              <h2>JC Nexus</h2>
              <p>
                Preview embroidery designs, customize thread colours, and
                estimate production time and cost in one workspace.
              </p>
            </div>

            <div className="sv-format-badge">
              <span>SUPPORTED FORMATS</span>
              <strong>DST · PES · JEF · EXP · VP3 · HUS · XXX · SVG</strong>
            </div>
          </section>

          {/* =================================================

              UPLOAD BAR

          \================================================= */}

          <section className="sv-control-card">
            <div className="sv-upload-info">
              <div className="sv-upload-icon">↑</div>

              <div>
                <strong>Upload embroidery design</strong>
                <span>Select a supported embroidery machine file to begin</span>
              </div>
            </div>

            {/* Instruction marquee in the middle */}
            <div
              className="sv-color-marquee"
              aria-label="Colour customization instructions"
            >
              <div className="sv-color-marquee-track">
                <span className="sv-marquee-item">
                  <span className="sv-marquee-icon">✳</span>
                  Click on a thread to change its colour
                </span>

                <span className="sv-marquee-separator">✦</span>

                <span className="sv-marquee-item">
                  <span className="sv-marquee-icon">◉</span>
                  Click on the background to change its colour
                </span>

                <span className="sv-marquee-separator">✦</span>

                {/* Duplicate items for a seamless loop */}
                <span className="sv-marquee-item" aria-hidden="true">
                  <span className="sv-marquee-icon">✳</span>
                  Click on a thread to change its colour
                </span>

                <span className="sv-marquee-separator" aria-hidden="true">
                  ✦
                </span>

                <span className="sv-marquee-item" aria-hidden="true">
                  <span className="sv-marquee-icon">◉</span>
                  Click on the background to change its colour
                </span>

                <span className="sv-marquee-separator" aria-hidden="true">
                  ✦
                </span>
              </div>
            </div>

            <div className="sv-upload-actions">
              <label className="sv-upload-btn">
                <span className="sv-upload-btn-icon">↑</span>
                <span>Choose File</span>

                <input
                  type="file"
                  accept=".dst,.pes,.jef,.exp,.vp3,.hus,.xxx,.svg"
                  onChange={this.uploadFile}
                  disabled={loading}
                />
              </label>

              {design && (
                <button
                  type="button"
                  className="sv-clear-btn"
                  onClick={this.clearDesign}
                >
                  <span>×</span>
                  Clear
                </button>
              )}
            </div>
          </section>

          {/* =================================================

              LOADING

          \================================================= */}

          {loading && (
            <div className="sv-loading-card">
              <div className="sv-loading-spinner" />

              <div className="sv-loading-content">
                <strong>Processing embroidery design</strong>

                <span>Reading stitches and preparing the visualization...</span>
              </div>

              <div className="sv-loading-progress">
                <span />
              </div>
            </div>
          )}

          {/* =================================================

              EMPTY STATE

          \================================================= */}

          {!design?.stitches && !loading && (
            <div className="sv-empty">
              <div className="sv-empty-illustration">
                <div className="sv-empty-ring">
                  <div className="sv-empty-thread">✦</div>
                </div>
              </div>

              <h3>No embroidery design loaded</h3>

              <p>
                Upload a DST, PES, JEF, EXP, VP3, HUS, XXX or SVG file to start
                exploring your design.
              </p>

              <label className="sv-empty-upload">
                Upload Design
                <input
                  type="file"
                  accept=".dst,.pes,.jef,.exp,.vp3,.hus,.xxx,.svg"
                  onChange={this.uploadFile}
                />
              </label>
            </div>
          )}

          {/* =================================================

              VIEWER

          \================================================= */}

          {design?.stitches && pathsData && (
            <section className="sv-viewer-card">
              {/* TOP TOOLBAR */}

              <div className="sv-toolbar">
                <div className="sv-toolbar-left">
                  <div className="sv-toolbar-title">
                    <span className="sv-live-dot" />

                    <strong>Stitch Preview</strong>
                  </div>

                  <div className="sv-toolbar-divider" />

                  <button
                    type="button"
                    className="sv-tool-btn"
                    onClick={this.zoomOut}
                    title="Zoom out"
                  >
                    −
                  </button>

                  <div className="sv-zoom-value">
                    {Math.round(scale * 100)}%
                  </div>

                  <button
                    type="button"
                    className="sv-tool-btn"
                    onClick={this.zoomIn}
                    title="Zoom in"
                  >
                    +
                  </button>

                  <button
                    type="button"
                    className="sv-fit-btn"
                    onClick={this.fitToScreen}
                  >
                    <span>⌗</span>
                    Fit
                  </button>
                </div>

                <div className="sv-toolbar-right">
                  <span className="sv-help-item">
                    <b>Scroll</b>
                    Zoom
                  </span>

                  <span className="sv-help-separator">•</span>

                  <span className="sv-help-item">
                    <b>Drag</b>
                    Pan
                  </span>

                  <span className="sv-help-separator">•</span>

                  <span className="sv-help-item">
                    <b>Click</b>
                    Thread
                  </span>
                </div>
              </div>

              {/* VIEWER AREA */}

              <div
                className="sv-svg-container"
                style={{ background: backgroundColor }}
              >
                {/* DESIGN BACKGROUND */}

                {/* SVG */}

                <svg
                  ref={this.svgRef}
                  className="sv-svg"
                  viewBox={`

                    ${pathsData.bounds.minX - 50}

                    ${pathsData.bounds.minY - 50}

                    ${pathsData.bounds.width + 100}

                    ${pathsData.bounds.height + 100}

                  `}
                  /*

                    IMPORTANT:

                    Never use "none" here.

                    It bends / stretches the embroidery.

                  */

                  preserveAspectRatio="xMidYMid meet"
                  onMouseDown={this.onMouseDown}
                  onMouseMove={this.onMouseMove}
                  onMouseUp={this.onMouseUp}
                  onMouseLeave={this.onMouseLeave}
                  onWheel={this.onWheel}
                  onClick={this.selectBackground}
                >
                  {/* =================================================

                      DESIGN TRANSFORM

                  \================================================= */}

                  <g
                    transform={`

                      translate(${offsetX} ${offsetY})

                      scale(${scale})

                    `}
                  >
                    {Object.entries(pathsData.paths).map(
                      ([key, points], index) => {
                        const d = this.buildPath(points);

                        const paletteColor = this.getPaletteColor(
                          key,

                          index,
                        );

                        const color = colorMap[key] || paletteColor;

                        const selected = selectedColor === key;

                        return (
                          <g key={key}>
                            {/* =================================================

                                LARGE CLICK AREA

                            \================================================= */}

                            <path
                              d={d}
                              className="sv-hit-path"
                              stroke="transparent"
                              strokeWidth={Math.max(
                                10,

                                16 /
                                  Math.max(
                                    scale,

                                    0.5,
                                  ),
                              )}
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              vectorEffect="non-scaling-stroke"
                              pointerEvents="stroke"
                              onClick={(e) =>
                                this.selectColor(
                                  e,

                                  key,

                                  color,
                                )
                              }
                            />

                            {/* =================================================

                                ACTUAL THREAD

                            \================================================= */}

                            <path
                              d={d}
                              stroke={color}
                              strokeWidth={selected ? 0.95 : 0.55}
                              fill="none"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              vectorEffect="non-scaling-stroke"
                              pointerEvents="none"
                              className={
                                selected
                                  ? "sv-thread sv-thread-selected"
                                  : "sv-thread"
                              }
                            />
                          </g>
                        );
                      },
                    )}
                  </g>
                </svg>

                {/* =================================================

                    CENTER WATERMARK

                \================================================= */}

                <div className="sv-canvas-watermark">EMBROIDERY PREVIEW</div>

                {cursorHint && !showPicker && (
                  <div
                    className={`sv-cursor-hint sv-cursor-hint-${cursorHint.type}`}
                    style={{
                      left: cursorHint.x,
                      top: cursorHint.y,
                    }}
                    aria-hidden="true"
                  >
                    <span className="sv-cursor-hint-icon">
                      {cursorHint.type === "thread" ? "✳" : "◉"}
                    </span>

                    <span className="sv-cursor-hint-copy">
                      <strong>
                        {cursorHint.type === "thread"
                          ? "Thread colour"
                          : "Canvas background"}
                      </strong>

                      <small>
                        {cursorHint.type === "thread"
                          ? "Click to change thread colour"
                          : "Click to change background colour"}
                      </small>
                    </span>
                  </div>
                )}

                {/* =================================================

                    COLOR PICKER

                \================================================= */}

                {showPicker && (
                  <div
                    className="sv-color-panel"
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                    onWheel={(e) => e.stopPropagation()}
                  >
                    <div className="sv-color-panel-header">
                      <div>
                        <div className="sv-picker-label">
                          {selectedColor === "__background__"
                            ? "CANVAS BACKGROUND"
                            : "THREAD COLOR"}
                        </div>

                        <strong>
                          {selectedColor === "__background__"
                            ? "Change Background Color"
                            : "Change Thread Color"}
                        </strong>

                        <span>
                          {selectedColor === "__background__"
                            ? "This color fills the entire preview area"
                            : "Select a new color"}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="sv-picker-close"
                        onClick={this.cancelColorPicker}
                      >
                        ×
                      </button>
                    </div>

                    <SketchPicker
                      color={pickerColor}
                      onChange={(color) =>
                        this.setState({
                          pickerColor: color.hex,
                        })
                      }
                    />

                    <div className="sv-selected-color">
                      <div
                        className="sv-color-preview"
                        style={{
                          background: pickerColor,
                        }}
                      />

                      <div className="sv-selected-color-info">
                        <span>Selected color</span>

                        <strong>{pickerColor.toUpperCase()}</strong>
                      </div>
                    </div>

                    <div className="sv-modal-actions">
                      <button
                        type="button"
                        className="sv-btn-primary"
                        onClick={this.applyColor}
                      >
                        Apply Color
                      </button>

                      <button
                        type="button"
                        className="sv-btn-danger"
                        onClick={this.cancelColorPicker}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </section>
          )}

          {/* DESIGN DETAILS + ESTIMATIONS */}

          {design?.stitches && pathsData && (
            <section className="jc-canvas-insights">
              {/* EMBROIDERY DETAILS */}
              <article className="jc-insight-card jc-details-card">
                <div className="jc-insight-heading">
                  <div className="jc-insight-icon jc-icon-orange">
                    <GiSewingMachine />
                  </div>

                  <div>
                    <span className="jc-card-eyebrow">DESIGN SUMMARY</span>
                    <h3>Embroidery Details</h3>
                  </div>
                </div>

                <div className="jc-metrics-grid">
                  <div className="jc-metric">
                    <span>Total stitches</span>
                    <strong>
                      {(preview.stitches + preview.jumps).toLocaleString(
                        "en-IN",
                      )}
                    </strong>
                  </div>

                  <div className="jc-metric">
                    <span>Thread colours</span>
                    <strong>{preview.colors}</strong>
                  </div>

                  <div className="jc-metric">
                    <span>Design width</span>
                    <strong>
                      {this.mmToInch(preview.width)} <small>in</small>
                    </strong>
                  </div>

                  <div className="jc-metric">
                    <span>Design height</span>
                    <strong>
                      {this.mmToInch(preview.height)} <small>in</small>
                    </strong>
                  </div>
                </div>
              </article>

              {/* STITCH TIME */}
              <article className="jc-insight-card">
                <div className="jc-insight-heading">
                  <div className="jc-insight-icon jc-icon-blue">
                    <GiSewingNeedle />
                  </div>

                  <div>
                    <span className="jc-card-eyebrow">PRODUCTION PLANNER</span>
                    <h3>Stitch Time Estimation</h3>
                  </div>
                </div>

                <div className="jc-estimate-control">
                  <div className="jc-control-label">
                    <label htmlFor="jc-machine-speed">Machine speed</label>
                    <strong>
                      {this.state.rpm.toLocaleString("en-IN")}{" "}
                      <small>stitches/min</small>
                    </strong>
                  </div>

                  <input
                    id="jc-machine-speed"
                    type="range"
                    min="350"
                    max="1200"
                    step="50"
                    value={this.state.rpm}
                    aria-label="Machine speed in stitches per minute"
                    onChange={(e) =>
                      this.setState({ rpm: Number(e.target.value) })
                    }
                    className="jc-range jc-range-blue"
                    style={{
                      "--range-progress": `${rpmProgress}%`,
                    }}
                  />

                  <div className="jc-range-labels">
                    <span>350 SPM</span>
                    <span>1,200 SPM</span>
                  </div>
                  <div className="jc-slider-tip">
                    <span>↔</span> Drag to adjust machine speed
                  </div>
                </div>

                <div className="jc-estimate-result jc-result-blue">
                  <span>Estimated stitching time</span>
                  <strong>
                    {(preview.stitches / this.state.rpm).toFixed(1)}
                    <small> min</small>
                  </strong>
                  <p>Calculated using the selected machine speed.</p>
                </div>
              </article>

              {/* PRICE ESTIMATION */}
              <article className="jc-insight-card">
                <div className="jc-insight-heading">
                  <div className="jc-insight-icon jc-icon-orange">
                    <span className="jc-rupee-symbol">₹</span>
                  </div>

                  <div>
                    <span className="jc-card-eyebrow">COST PLANNER</span>
                    <h3>Price Estimation</h3>
                  </div>
                </div>

                <div className="jc-estimate-control">
                  <div className="jc-control-label">
                    <label htmlFor="jc-price-rate">
                      Rate per 10,000 stitches
                    </label>
                    <strong>₹{this.state.pricePer10k}</strong>
                  </div>

                  <input
                    id="jc-price-rate"
                    type="range"
                    min="50"
                    max="500"
                    step="10"
                    value={this.state.pricePer10k}
                    aria-label="Price per 10,000 stitches"
                    onChange={(e) =>
                      this.setState({ pricePer10k: Number(e.target.value) })
                    }
                    className="jc-range jc-range-orange"
                    style={{
                      "--range-progress": `${priceProgress}%`,
                    }}
                  />

                  <div className="jc-range-labels">
                    <span>₹50</span>
                    <span>₹500</span>
                  </div>
                  <div className="jc-slider-tip">
                    <span>↔</span> Drag to adjust the rate
                  </div>
                </div>

                <div className="jc-estimate-result jc-result-orange">
                  <span>Estimated production cost</span>
                  <strong>
                    {Math.max(
                      50,
                      (preview.stitches / 10000) * this.state.pricePer10k,
                    ).toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                      maximumFractionDigits: 0,
                    })}
                  </strong>
                  <p>Based on the selected per-stitch pricing rate.</p>
                </div>
              </article>
            </section>
          )}
        </main>
      </div>
    );
  }
}

export default SvgViewer;
